var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { TableRow } from '@pocketlaw/tetris';
import { useHistory } from 'react-router-dom';
import { getSearchEntityLink } from 'app/domains/global-search/utils/getSearchEntityLink';
import { SearchResultsTableCell } from './SearchResultsTableCell';
export const SearchResultsTableRow = forwardRef((props, tetrisRef) => {
    const { result, columnConfigs } = props, tetrisProps = __rest(props, ["result", "columnConfigs"]);
    const history = useHistory();
    const handleSelect = () => {
        const link = getSearchEntityLink(result.type, result.entityId);
        history.push(link);
    };
    return (<TableRow onSelect={handleSelect} ref={tetrisRef} {...tetrisProps}>
        {columnConfigs.map(column => (<SearchResultsTableCell key={column.id} column={column} result={result}/>))}
      </TableRow>);
});
